// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1eEjd","detailsBorder":"styles_detailsBorder__28qEx"};